module.exports = "<div class=\"py-4\"><inquiry-assignment-list-item inquiry=\"$ctrl.item.record\"></inquiry-assignment-list-item></div>";